<template>
    <div id="app" class="o-page-wrapper">
        <a class="c-header__fixed-icon u-link-clean" href="/">
            <img src="https://protestantsekerk.nl/static/images/logo-trademark-protestantse-kerk.svg" alt="Protestantse Kerk">
        </a>
        <header class="c-header" data-behaviour="Header">
            <a class="u-hidden-visually" id="skip-to-content" href="#content">Doorgaan naar hoofdinhoud</a>
            <div class="c-header__topbar">
                <div class="c-header__top o-grid">
                    <a class="u-link-clean" href="https://protestantsekerk.nl/">
                        <img class="c-header__logo" src="https://protestantsekerk.nl/static/images/logo-protestantse-kerk.svg"
                             alt="Protestantse Kerk">
                        <img class="c-header__wordmark-logo"
                             src="https://protestantsekerk.nl/static/images/logo-wordmark-protestantse-kerk.svg" alt="Protestantse Kerk">
                    </a>
                    <div class="o-grid__item o-grid o-grid--align-right">
                        <div class="c-header__tagline">
                            <svg version="1.1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px" viewBox="0 0 142.3 26.2" style="enable-background:new 0 0 142.3 26.2;"
                                 xml:space="preserve" width="142.3" height="26.2" fill="#E98C00">
                                <path d="M46 0h1.4l2.3 6.5c.1.5.3 1.2.3 1.2s.2-.8.3-1.3L52.6 0H54l-3.4 9.1h-1.3L46 0zM55.2 0h1.3v1.3h-1.3V0zm0 2.6h1.3v6.5h-1.3V2.6zM58.5 2.6h1.2V4c.3-.6 1-1.5 2.5-1.5s2.3.8 2.3 2.5v4.2h-1.3v-4c0-.9-.2-1.6-1.2-1.6s-1.8.7-2.1 1.6c-.1.3-.1.6-.1.9v3.1h-1.3V2.6zM69 2.4c1.5 0 2 1 2 1V0h1.3v9.1h-1.2v-.6-.4s-.5 1.2-2.1 1.2c-1.8 0-2.9-1.4-2.9-3.4-.1-2.1 1.2-3.5 2.9-3.5zm.2 5.8c1 0 1.9-.7 1.9-2.4 0-1.2-.6-2.3-1.8-2.3-1 0-1.9.9-1.9 2.3-.1 1.5.7 2.4 1.8 2.4zM74.4 2.6h1.2v1.1s.6-1.2 2.2-1.2c1.8 0 2.9 1.4 2.9 3.4 0 2.1-1.3 3.4-3 3.4-1.4 0-2-1.1-2-1.1v3.5h-1.3V2.6zm3 5.6c1 0 1.9-.9 1.9-2.3s-.8-2.3-1.8-2.3-1.9.7-1.9 2.4c0 1.1.6 2.2 1.8 2.2zM82.2 0h1.3v7.1c0 .8.3.9.7.9h.2v1.1H84c-.7 0-1.8-.2-1.8-1.8V0zM89.2 5.1h.3v-.2c0-1.1-.6-1.4-1.4-1.4-1 0-1.8.6-1.8.6l-.5-.9s.9-.8 2.4-.8c1.7 0 2.6.9 2.6 2.6v4.1h-1.2v-.6V8s-.5 1.3-2.1 1.3c-1.1 0-2.2-.7-2.2-2 0-2.2 2.8-2.2 3.9-2.2zm-1.4 3.2c1.1 0 1.7-1.1 1.7-2.1V6h-.3c-.9 0-2.7.1-2.7 1.2.1.6.5 1.1 1.3 1.1zM96.2 5.1h.3v-.2c0-1.1-.6-1.4-1.4-1.4-1 0-1.8.6-1.8.6l-.5-.9s.9-.8 2.4-.8c1.7 0 2.6.9 2.6 2.6v4.1h-1.2v-.6V8s-.5 1.3-2.1 1.3c-1.1 0-2.2-.7-2.2-2 0-2.2 2.8-2.2 3.9-2.2zm-1.4 3.2c1.1 0 1.7-1.1 1.7-2.1V6h-.3c-.9 0-2.7.1-2.7 1.2 0 .6.4 1.1 1.3 1.1zM100 3.7h-.9v-1h.9V.8h1.2v1.9h1.6v1h-1.6v2.9c0 1.3.9 1.5 1.4 1.5h.3v1.1h-.4c-.8 0-2.5-.3-2.5-2.4V3.7zM104.5 7.4s.7.8 1.9.8c.5 0 1.1-.3 1.1-.8 0-1.2-3.4-1-3.4-3.1 0-1.2 1.1-1.9 2.4-1.9 1.4 0 2.1.7 2.1.7l-.5.9s-.6-.6-1.6-.6c-.5 0-1.1.2-1.1.8 0 1.2 3.4.9 3.4 3.1 0 1.1-.9 1.9-2.4 1.9-1.6 0-2.5-1-2.5-1l.6-.8zM113 2.6h1.3l1.6 4.4c.1.4.2.9.2.9s.1-.5.2-.9l1.6-4.4h1.3l-2.4 6.5h-1.4L113 2.6zM123.9 5.1h.3v-.2c0-1.1-.6-1.4-1.4-1.4-1 0-1.8.6-1.8.6l-.5-.9s.9-.8 2.4-.8c1.7 0 2.6.9 2.6 2.6v4.1h-1.2v-.6V8s-.5 1.3-2.1 1.3c-1.1 0-2.2-.7-2.2-2-.1-2.2 2.8-2.2 3.9-2.2zm-1.5 3.2c1.1 0 1.7-1.1 1.7-2.1V6h-.3c-.9 0-2.7.1-2.7 1.2.1.6.5 1.1 1.3 1.1zM127.4 2.6h1.2V4c.3-.6 1-1.5 2.5-1.5s2.3.8 2.3 2.5v4.2h-1.3v-4c0-.9-.2-1.6-1.2-1.6s-1.8.7-2.1 1.6c-.1.3-.1.6-.1.9v3.1h-1.3V2.6zM2.8 25.1c1.1 0 2.1-.5 2.1-1.8v-.5-.4c-.4.6-1 1-1.9 1C1.2 23.4.1 21.9.1 20s1-3.3 2.9-3.3c1.6 0 2.1 1 2.1 1v-.8h1.2v6.3c0 2.2-1.6 3-3.3 3-.8 0-1.6-.2-2.2-.5l.4-1c-.2 0 .6.4 1.6.4zm2.1-5c0-1.7-.8-2.2-1.8-2.2-1.1 0-1.8.8-1.8 2.2 0 1.4.7 2.3 1.9 2.3.9-.1 1.7-.6 1.7-2.3zM11 16.8c1.8 0 2.8 1.4 2.8 3.1v.5H9.1c.1 1.4 1.1 2.2 2.3 2.2 1.1 0 1.9-.8 1.9-.8l.5.9s-1 .9-2.5.9c-2.1 0-3.5-1.5-3.5-3.4 0-2.1 1.4-3.4 3.2-3.4zm1.6 2.6c0-1.1-.7-1.7-1.6-1.7-1 0-1.7.6-1.9 1.7h3.5zM15.5 14.4h1.3v7.1c0 .8.3.9.7.9h.2v1.1h-.4c-.7 0-1.8-.2-1.8-1.8v-7.3zM22.1 16.8c2 0 3.5 1.4 3.5 3.4s-1.6 3.4-3.5 3.4c-2 0-3.5-1.4-3.5-3.4s1.6-3.4 3.5-3.4zm0 5.8c1.2 0 2.3-1 2.3-2.4s-1-2.3-2.3-2.3c-1.2 0-2.3 1-2.3 2.3.1 1.4 1.1 2.4 2.3 2.4zM30.4 16.8c2 0 3.5 1.4 3.5 3.4s-1.6 3.4-3.5 3.4c-2 0-3.5-1.4-3.5-3.4-.1-2 1.5-3.4 3.5-3.4zm0 5.8c1.2 0 2.3-1 2.3-2.4s-1-2.3-2.3-2.3c-1.2 0-2.3 1-2.3 2.3 0 1.4 1 2.4 2.3 2.4zM35.8 18H35v-1h.8v-.3c0-2.2 1.6-2.4 2.5-2.4h.5v1.1h-.3c-.5 0-1.4.2-1.4 1.4v.2h1.6v1h-1.6v5.4h-1.2V18zM40 22.1h1.3l-1.1 2.7h-1l.8-2.7zM46.7 14.4H48v3.9c.3-.6 1.1-1.5 2.4-1.5 1.5 0 2.3.8 2.3 2.5v4.2h-1.3v-3.9c0-.9-.2-1.6-1.2-1.6s-1.8.7-2.1 1.6c-.1.2-.1.5-.1.8v3.1h-1.3v-9.1zM57.7 16.8c2 0 3.5 1.4 3.5 3.4s-1.6 3.4-3.5 3.4c-2 0-3.5-1.4-3.5-3.4s1.6-3.4 3.5-3.4zm0 5.8c1.2 0 2.3-1 2.3-2.4s-1-2.3-2.3-2.3c-1.2 0-2.3 1-2.3 2.3.1 1.4 1.1 2.4 2.3 2.4zM65.9 16.8c2 0 3.5 1.4 3.5 3.4s-1.6 3.4-3.5 3.4c-2 0-3.5-1.4-3.5-3.4s1.6-3.4 3.5-3.4zm0 5.8c1.2 0 2.3-1 2.3-2.4s-1-2.3-2.3-2.3c-1.2 0-2.3 1-2.3 2.3.1 1.4 1.1 2.4 2.3 2.4zM71.1 16.9h1.2V18s.6-1.2 2.2-1.2c1.8 0 2.9 1.4 2.9 3.4 0 2.1-1.3 3.4-3 3.4-1.4 0-2-1.1-2-1.1V26h-1.3v-9.1zm3 5.7c1 0 1.9-.9 1.9-2.3s-.8-2.3-1.8-2.3-1.9.7-1.9 2.4c0 1 .6 2.2 1.8 2.2zM85.2 16.8c1.8 0 2.8 1.4 2.8 3.1v.5h-4.8c.1 1.4 1.1 2.2 2.3 2.2 1.1 0 1.9-.8 1.9-.8l.5.9s-1 .9-2.5.9c-2.1 0-3.5-1.5-3.5-3.4.1-2.1 1.5-3.4 3.3-3.4zm1.6 2.6c0-1.1-.7-1.7-1.6-1.7-1 0-1.7.6-1.9 1.7h3.5zM89.7 16.9h1.2v1.4c.3-.6 1-1.5 2.5-1.5s2.3.8 2.3 2.5v4.2h-1.3v-3.9c0-.9-.2-1.6-1.2-1.6s-1.8.7-2.1 1.6c-.1.2-.1.5-.1.8v3.1h-1.3v-6.6zM101 14.4h1.3v7.1c0 .8.3.9.7.9h.2v1.1h-.4c-.7 0-1.8-.2-1.8-1.8v-7.3zM104.6 14.4h1.3v1.3h-1.3v-1.3zm.1 2.5h1.3v6.5h-1.3v-6.5zM110.8 16.8c1.8 0 2.8 1.4 2.8 3.1v.5h-4.8c.1 1.4 1.1 2.2 2.3 2.2 1.1 0 1.9-.8 1.9-.8l.5.9s-1 .9-2.5.9c-2.1 0-3.5-1.5-3.5-3.4.1-2.1 1.5-3.4 3.3-3.4zm1.6 2.6c0-1.1-.7-1.7-1.6-1.7-1 0-1.7.6-1.9 1.7h3.5zM115.7 18h-.8v-1h.8v-.3c0-2.2 1.6-2.4 2.5-2.4h.5v1.1h-.3c-.5 0-1.4.2-1.4 1.4v.2h1.6v1H117v5.4h-1.2V18zM122.3 16.8c1.5 0 2 1 2 1v-3.4h1.3v9.1h-1.2v-.6-.4s-.5 1.2-2.1 1.2c-1.8 0-2.9-1.4-2.9-3.4 0-2.2 1.2-3.5 2.9-3.5zm.2 5.8c1 0 1.9-.7 1.9-2.4 0-1.2-.6-2.3-1.8-2.3-1 0-1.9.9-1.9 2.3s.7 2.4 1.8 2.4zM130.5 16.8c1.8 0 2.8 1.4 2.8 3.1v.5h-4.8c.1 1.4 1.1 2.2 2.3 2.2 1.1 0 1.9-.8 1.9-.8l.5.9s-1 .9-2.5.9c-2.1 0-3.5-1.5-3.5-3.4.1-2.1 1.5-3.4 3.3-3.4zm1.6 2.6c0-1.1-.7-1.7-1.6-1.7-1 0-1.7.6-1.9 1.7h3.5z"/>
                                <g><path d="M141.4 0h.9v23.5h-.9z"/></g>
                            </svg>
                        </div>
                        <div class="c-header__navigation-toggle">
                        </div>
                    </div>
                </div>
                <div class="c-header__navigation u-text-center" role="navigation" data-behaviour="ScrollHeader">

                </div>
            </div>
            <svg class="c-header__subline" xmlns="http://www.w3.org/2000/svg" width="258" height="82.18" viewBox="0 0 258 82.18">
                <title>subline-curl</title>
                <path class="background" d="M0,0.1l0,81.1l0,0C64.2,34,144.3,3.5,258,1.1V0L0,0.1z"/>
                <path class="line" d="M258,0.1L258,0.1"/>
                <path class="line" d="M0,80.9l0,1.2C72.9,28.5,152.8,3.6,258,2.1v-1c-9.1,0.1-18,0.4-26.8,0.9C138.9,7.1,66.7,31.8,0,80.9z"/>
            </svg>
            <div class="c-header__subnavigation u-text-right"></div>
        </header>

        <div v-if="networkError" class="tac">
            <p>Er is een fout opgetreden bij het laden van de quiz.</p>
            <b-button @click="loadData">Probeer opnieuw</b-button>
        </div>

        <div v-if="loading" class="tac">
            <p v-if="!networkError">Een momentje alsjeblieft...</p>
        </div>

        <router-view v-else/>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: true,
            networkError: false,
            errorMessage: {}
        };
    },
    methods: {
        loadData() {
            var that = this;

            axios
                .get("https://kernwaarden.protestantsekerk.nl/info/")
                .then(function (response) {
                    // handle success
                    that.networkError = false;
                    that.data = response.data;
                    axios
                        .get("https://api.protestantsekerk.nl/gemeenten/")
                        .then(function (response) {
                            // handle success
                            that.networkError = false;
                            that.loading = false;
                            that.congregations = response.data.data;
                        })
                        .catch(function (error) {
                            that.networkError = true;
                            that.errorMessage = error;
                        });
                })
                .catch(function (error) {
                    that.networkError = true;
                    that.errorMessage = error;
                });
        }
    },
    computed: {
        congregations: {
            get() {
                return this.$store.state.congregations;
            },
            set(newValue) {
                return this.$store.dispatch("setCongregations", newValue);
            }
        },
        data: {
            get() {
                return this.$store.state.data;
            },
            set(newValue) {
                return this.$store.dispatch("setData", newValue);
            }
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style>
#nav {
	padding: 30px;
}

.c-header__logo {
	height: 3.5rem;
}

.tac {
	text-align: center;
}
</style>
